import React from 'react';

import Header from 'src/components/common/header';

import type { MainLayoutProps } from './main-layout.props';

import './main-layout.scss';

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="main-layout">
      <Header />
      <div className="main-layout__content">{children}</div>
    </div>
  );
};

export default MainLayout;
